import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import React, { useState } from "react";

function FindKeyWorking() {
  return <div>Find Key Working</div>;
}

function FindKeySuccess(props) {
  return (
    <div>
      <h1>License key found</h1>
      <p>Your license key has been found, and has been emailed to {props.email}.</p>
      <p>Thanks for buying PlaneCommand!</p>

      <Button type="submit" variant="primary" className="mx-auto d-block" onClick={(event) => props.reset()}>
        <i className="fas fa-arrow-left" aria-hidden="true"></i> Search again
      </Button>
    </div>
  );
}

function FindKeyFailure(props) {
  return (
    <>
      <h3>License key not found</h3>
      <p className="text-danger">
        No license key was found for address <b>{props.email}</b>.
      </p>

      <Button variant="primary" role="button" onClick={(event) => props.reset()}>
        Search again
      </Button>
    </>
  );
}

function FindKeyError(props) {
  return (
    <>
      <h1>Error: failed to send licence key email</h1>
      <p>
        The license key has been found for {props.email}, but we encountered an error while trying to email it to you.
      </p>
      <p>Please send me an email at lee@planecommand.com, and I'll send it to you manually.</p>
      <p>Thanks for buying PlaneCommand!</p>

      <Button type="submit" variant="primary" className="mx-auto d-block" onClick={(event) => props.reset()}>
        <i className="fas fa-arrow-left" aria-hidden="true"></i> Search again
      </Button>
    </>
  );
}

function FindKeyForm(props) {
  return (
    <div id="email_lookup" className="row py-3">
      <p className="lead">
        If you have already purchased PlaneCommand and can't find your license key, look it up here. Your key will be
        emailed to you.
      </p>

      <Form
        id="find-key-form"
        className="offset-md-4 col-md-4 offset-sm-2 col-sm-8"
        onSubmit={(event) => {
          event.preventDefault();
          props.lookupFunc(props.email);
        }}
      >
        <Form.Group controlId="license_email" className="form-group">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="pilot@example.com"
            className="form-control"
            name="license_email"
            value={props.email}
            required
            onChange={(element) => props.setEmail(element.target.value)}
          />
        </Form.Group>
        <Form.Group className="form-group">
          <Button
            type="submit"
            variant="primary"
            className="mx-auto d-block my-4"
          >
            <i className="fa-solid fa-search" aria-hidden="true"></i> Look up license key
          </Button>
        </Form.Group>
        <p className="text-muted">
          {" "}
          If you can't find your license key using this page, email me at{" "}
          <a href="mailto:lee@planecommand.com">lee@planecommand.com</a> for help.
        </p>
      </Form>
    </div>
  );
}
enum FindKeyStage {
  Form = 1,
  Working,
  Result,
  Error,
}

export function FindKey(props) {
  let [stage, setStage] = useState(FindKeyStage.Form);

  let [email, setEmail] = useState("");

  let [found, setFound] = useState(false);

  function lookupKey(email: string) {
    setStage(FindKeyStage.Working);

    fetch("/api/find_key", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: new URLSearchParams({ license_email: email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`License lookup failed (${response.status})`);
        }
        return response.json();
      })
      .then((data) => {
        setFound(Boolean(data.found));
        setStage(FindKeyStage.Result);
      })
      .catch(() => {
        setStage(FindKeyStage.Error);
      });
  }

  return (
    <>
      {stage == FindKeyStage.Form && (
        <FindKeyForm lookupFunc={lookupKey} email={email} setEmail={setEmail} {...props} />
      )}
      {stage == FindKeyStage.Working && <FindKeyWorking email={email} {...props} />}
      {stage == FindKeyStage.Result && (
        <>
          {found && <FindKeySuccess email={email} reset={() => setStage(FindKeyStage.Form)} {...props} />}
          {!found && <FindKeyFailure email={email} reset={() => setStage(FindKeyStage.Form)} {...props} />}
        </>
      )}
      {stage == FindKeyStage.Error && <FindKeyError email={email} reset={() => setStage(FindKeyStage.Form)} {...props} />}
    </>
  );
}
